// src/components/info/Careers.jsx
import React from 'react';
import ShortTests from '../shorts/Tests';
import ShortNews from '../shorts/News';
import { Helmet } from 'react-helmet-async';
import AdSlot from '../ads/AdSlot';

import '../../assets/css/careers.css'

const Careers = () => {
  const pageTitle = 'Karriere | NGCTV';
  const pageDescription =
    'Karriere bei NGCTV: Aktuell keine offenen Positionen, aber wir freuen uns über Initiativbewerbungen von Gaming- und Technikbegeisterten. Werde Teil unserer Community!';

  return (
    <>
      {/* SEO / Head */}
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://ngctv.de/karriere" />
      </Helmet>

      <main>
        <div className="wrapper">
          <div className="rows">
            <div className="row">
              <div className="category">Karriere</div>

              <div className="careers">
                <p>
                  <strong>Aktuell haben wir keine offenen Positionen.</strong>
                  <br />
                  NGCTV wächst kontinuierlich weiter – mit einer Community, die Gaming und
                  Technik liebt. Wenn du dir vorstellen kannst, uns mit deiner Erfahrung
                  und Leidenschaft zu unterstützen, melde dich trotzdem gerne bei uns.
                </p>

                <br />

                <h3>Initiativbewerbung</h3>
                <p>
                  Schicke uns eine kurze Vorstellung, deinen Schwerpunkt (z.&nbsp;B.
                  News, Tests, Redaktion, Social, Video, Technik) sowie relevante
                  Referenzen/Arbeitsproben. Erzähl uns, was dich motiviert und wie du
                  NGCTV bereichern möchtest.
                </p>

                <ul>
                  <li>Kurzer Lebenslauf oder Portfolio</li>
                  <li>2–3 Arbeitsproben (Links oder PDF)</li>
                  <li>Wunschbereich &amp; zeitliche Verfügbarkeit</li>
                </ul>

                <br />

                <h3>So erreichst du uns</h3>
                <p>
                  Am einfachsten über unser Kontaktformular
                  {` `}
                  <a href="/kontakt">/kontakt</a>
                  {` `}
                  oder per E-Mail an
                  {` `}
                  <a href="mailto:info@ngctv.de">info@ngctv.de</a>.
                </p>

                <br />

                <h3>Warum NGCTV?</h3>
                <ul>
                  <li>Fokus auf Gaming &amp; Technik – von PC über Konsole bis Handheld</li>
                  <li>Unabhängige Berichterstattung und Community-Nähe</li>
                  <li>Eigenverantwortung, kurze Wege, viel Gestaltungsspielraum</li>
                </ul>

                <br />
                <p>
                  Wir freuen uns auf deine Nachricht – auch wenn es gerade keine offizielle
                  Ausschreibung gibt. <strong>Let’s build NGCTV together!</strong>
                </p>
              </div>
            </div>

            <div className="row">
              <ShortTests />
              <ShortNews />
              <AdSlot slot="2119524913" />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Careers;
